import React, { useMemo } from 'react'
import { View } from 'react-native'

export default function Spacer({ height = 10, width = 0 }) {
  const style = useMemo(() => ({ height, width }), [height, width])
  return <View style={style} />
}
